
const activities = [
  {
    category: '水上活動',
    icon: 'ri-sailboat-line',
    items: ['SUP立槳', '浮潛生態導覽', '獨木舟', '衝浪', '遊艇帆船滑水', '快艇']
  },
  {
    category: '陸上行程',
    icon: 'ri-map-pin-line',
    items: ['專家觀星導覽', '潮間帶導覽']
  }
];

const nearbyAttractions = [
  { name: '貓鼻頭公園', icon: 'ri-landscape-line' },
  { name: '白沙灣', icon: 'ri-sun-line' },
  { name: '小狗灣', icon: 'ri-water-flash-line' },
  { name: '後壁湖', icon: 'ri-ship-line' }
];

export default function About() {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">關於我們</h2>
          <p className="text-xl text-gray-600">遠離塵囂，擁抱自然</p>
        </div>

        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              位於<strong className="text-teal-600">屏東恆春下水泉</strong>的歐美風格小木屋，鄰近沙灘，是小孩也是毛小孩的天堂，環境優美，人少幽靜，抵達海邊開車僅要3~5分鐘，歡迎喜愛大自然的你來脫離都市生活。
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              鄰近貓鼻頭公園、白沙灣、小狗灣、後壁湖等地區，遠離塵囂，並提供卡拉OK、烤肉區等設備。
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              想不到要去哪裡玩嗎？通通交給我們，聯絡我們安排您的旅遊大小事，讓家人孩子放鬆，自己也輕鬆！
            </p>
          </div>
        </div>

        {/* Nearby Attractions */}
        <div className="mb-16">
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-8">鄰近景點</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
            {nearbyAttractions.map((attraction, idx) => (
              <div 
                key={idx}
                className="bg-white rounded-xl p-6 text-center shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              >
                <div className="w-16 h-16 mx-auto mb-4 bg-teal-100 rounded-full flex items-center justify-center">
                  <i className={`${attraction.icon} text-3xl text-teal-600`}></i>
                </div>
                <h4 className="text-lg font-semibold text-gray-900">{attraction.name}</h4>
              </div>
            ))}
          </div>
        </div>

        {/* Activities */}
        <div className="max-w-5xl mx-auto">
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-8">精彩活動</h3>
          <div className="grid md:grid-cols-2 gap-8">
            {activities.map((activity, idx) => (
              <div key={idx} className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-2xl p-8 shadow-lg">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-12 h-12 bg-teal-500 rounded-full flex items-center justify-center">
                    <i className={`${activity.icon} text-2xl text-white`}></i>
                  </div>
                  <h4 className="text-2xl font-bold text-gray-900">{activity.category}</h4>
                </div>
                <div className="flex flex-wrap gap-3">
                  {activity.items.map((item, itemIdx) => (
                    <span 
                      key={itemIdx}
                      className="px-4 py-2 bg-white text-teal-700 font-medium rounded-full shadow-sm hover:shadow-md transition-shadow cursor-pointer"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-6">
            <i className="ri-information-line mr-2"></i>
            如需包車接送服務，請於訂購前與我們聯繫，好替您安排，讓旅遊一無掛慮
          </p>
          <a
            href="https://lin.ee/i6pwzIh"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-green-500 hover:bg-green-600 text-white font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-line-fill text-xl"></i>
            加入 LINE 好友
          </a>
        </div>
      </div>
    </section>
  );
}
